import o from "./index645.js";
import { withInstall as t } from "./index604.js";
const l = t(o);
export {
  l as ElDialog,
  l as default
};
